import moment from 'moment'
import config from 'constants/config'
import { OFFER_TYPE_ALWAYS_ON, OFFER_TYPE_HOTEL } from 'constants/offer'
import { dateIsAfter, subDays } from 'lib/datetime/dateUtils'
import { FOURTEEN_DAYS_BEFORE_CHECK_IN, THREE_DAYS_BEFORE_CHECK_IN } from 'constants/cancellationPolicies'
import { isConnectionCancellationPolicy, isCancellationPolicy, isWithinSevenDays, isFlexibleCancellationPolicy } from 'lib/offer/cancellationPolicyUtils'
import { ITEM_STATUS_COMPLETED } from 'constants/cart'
import { PACKAGE_CHANGE_DOWNGRADE_TYPES, DOWNGRADE_TYPE_CHANGE_DATES_TACTICAL_AO_HOTEL, DOWNGRADE_TYPE_BNBL } from 'constants/reservation'

interface OrderDetails {
  cancellationPolicy: App.OrderCancellationPolicyTypes;
  offer: App.Offer | App.OrderItemOffer;
  order: App.Order;
  reservation: App.OrderReservation;
  hideCancellation: boolean;
}

export function getCancellationConfig({ cancellationPolicy, offer, order, reservation, hideCancellation }: OrderDetails) {
  const configs = {
    refundable: false,
    shouldHideFreeCancellation: false,
    withinChangeOfMind: false,
    changeOfMindPriorityPolicy: false,
    deadline: undefined,
  }

  if (cancellationPolicy) {
    if (isConnectionCancellationPolicy(cancellationPolicy)) {
      configs.refundable = !cancellationPolicy.nonRefundable
      configs.deadline = cancellationPolicy.deadline
    } else if (isCancellationPolicy(cancellationPolicy)) {
      if (((config.ENABLE_REFUND_FOR_FLASH_OFFER && offer.type === OFFER_TYPE_HOTEL) || offer.type === OFFER_TYPE_ALWAYS_ON)) {
        configs.refundable = cancellationPolicy.type !== 'non-refundable'
        configs.deadline = cancellationPolicy.start
        configs.withinChangeOfMind = isWithinSevenDays(order.createdAt, reservation?.startDate, new Date())
        configs.changeOfMindPriorityPolicy = cancellationPolicy.type === 'post-purchase-seven-days' || isFlexibleCancellationPolicy(cancellationPolicy)
        if (cancellationPolicy.type === 'refundable' && offer.type === OFFER_TYPE_HOTEL) {
          configs.shouldHideFreeCancellation = true
        }
      }
    }
  }

  configs.shouldHideFreeCancellation =
  configs.shouldHideFreeCancellation ||
    !configs.deadline ||
    hideCancellation ||
    (reservation?.startDate && dateIsAfter(new Date(), new Date(reservation.startDate))) ||
    dateIsAfter(new Date(), new Date(configs.deadline))

  configs.shouldHideFreeCancellation = configs.changeOfMindPriorityPolicy ? configs.shouldHideFreeCancellation && !configs.withinChangeOfMind : configs.shouldHideFreeCancellation
  const changeOfMindDeadline = subDays(new Date(reservation?.startDate), FOURTEEN_DAYS_BEFORE_CHECK_IN)
  configs.deadline = dateIsAfter(new Date(), new Date(configs.deadline)) && configs.changeOfMindPriorityPolicy ? changeOfMindDeadline : configs.deadline

  return configs
}

export function canBeUpgraded(item: App.OrderItem) {
  if (!config.PACKAGE_CHANGE_UPGRADE_ENABLED) {
    return false
  }

  if (item.status === ITEM_STATUS_COMPLETED) {
    const checkInDate = item?.reservation?.startDate
    const finalDateAllowed = moment(checkInDate).subtract(THREE_DAYS_BEFORE_CHECK_IN, 'days')
    return moment().startOf('day').isSameOrBefore(finalDateAllowed)
  }
  return false
}

export function bookingsPriority(a: App.OrderItem, b: App.OrderItem) {
  const bookingPreference = [...PACKAGE_CHANGE_DOWNGRADE_TYPES, DOWNGRADE_TYPE_CHANGE_DATES_TACTICAL_AO_HOTEL, DOWNGRADE_TYPE_BNBL]

  const index1 = bookingPreference.indexOf(a.downgradeType)
  const index2 = bookingPreference.indexOf(b.downgradeType)
  return index1 == -1 ? 1 : index2 == -1 ? -1 : index1 - index2
}
